import { Flex, Text, Box, Avatar, Grid, GridItem, Center, Button } from '@chakra-ui/react';
import { trpcTenant } from '@duke-hq/app-provider-web/tenant/trpcTenant';
import { UserAppEvents } from '@duke-hq/ui/components/UserAppEvents/UserAppEvents';
import { User } from '@duke-hq/svc-api-db';
import { RouterOutputs } from '@duke-hq/svc-api/provider';
import { Trans } from '@lingui/react/macro';

function AvatarName({ user }: { user: Partial<User> }) {
  const consultantFullName = user.first_name + (user.last_name ? ' ' + user.last_name : '');
  return (
    <Flex gap={3} alignItems="center">
      <Avatar size="xs" name={consultantFullName} src={user.picture_url ?? undefined} />
      <Text fontSize="sm" color="fg.default" fontWeight="medium">
        {consultantFullName}
      </Text>
    </Flex>
  );
}

export function StudentRecentActivity({
  studentId,
  consultant,
}: {
  studentId: string;
  consultant: RouterOutputs['users']['consultantById'] | undefined;
}) {
  if (!studentId) {
    return null;
  }

  const { data, fetchNextPage, hasNextPage, isFetching } =
    trpcTenant.users.studentActivity.useInfiniteQuery(
      {
        userId: studentId,
      },
      {
        getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
        enabled: !!studentId,
      },
    );

  const activityItems = data?.pages.flatMap((page) => page.items ?? []) ?? [];

  return (
    <GridItem colSpan={2} h="full">
      <Flex h="full" bg="bg.canvas" borderLeftWidth="1px" direction="column" width="full">
        <Box
          position="sticky"
          top="0"
          bg="bg.surface"
          paddingLeft="8px"
          borderBottomWidth="2px"
          borderBottomColor="border.default"
          color="fg.subtle"
          p={4}
        >
          <Grid templateRows="repeat(2, 1fr)" templateColumns="auto 1fr" rowGap={3}>
            <GridItem>
              <Text p={2} textStyle="sm" color="fg.muted">
                <Trans>Assessor</Trans>:
              </Text>
            </GridItem>
            <GridItem>
              <Flex alignItems="center" py={1.5} px={2}>
                <Text fontSize="sm" color="fg.default" fontWeight="medium">
                  N/A
                </Text>
              </Flex>
            </GridItem>
            <GridItem>
              <Text p={2} textStyle="sm" color="fg.muted">
                <Trans>Consultant</Trans>:
              </Text>
            </GridItem>
            <GridItem>
              <Flex alignItems="center" py={1.5} px={2}>
                {consultant ? <AvatarName user={consultant} /> : '-'}
              </Flex>
            </GridItem>
          </Grid>
        </Box>

        {activityItems.length > 0 && (
          <Flex direction="column" flex="1" minHeight={0}>
            <Box flex="1" overflowY="auto" py={{ base: '4', md: '8' }} px={4}>
              <UserAppEvents studentActivityItems={activityItems} />
            </Box>

            {hasNextPage ? (
              <Box
                position="sticky"
                bottom="0"
                bg="bg.surface"
                borderTopWidth="1px"
                borderColor="border.default"
                py={4}
                px={4}
                zIndex={1}
              >
                <Center>
                  <Button onClick={() => fetchNextPage()} isLoading={isFetching}>
                    <Trans>Load more</Trans>
                  </Button>
                </Center>
              </Box>
            ) : null}
          </Flex>
        )}
      </Flex>
    </GridItem>
  );
}
